import React from "react";

import { useTranslation } from "@refinedev/core";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Stack, Typography } from "@mui/material";

/**
 * Full page permission denied component
 * Used for route-level permission checks (CanAccess fallback)
 */
export const PermissionDeniedPage: React.FC = () => {
  const { translate } = useTranslation();

  return (
    <Stack spacing={3} alignItems="center" justifyContent="center" minHeight="60vh" p={4}>
      <ErrorOutlineIcon color="secondary" sx={{ fontSize: "4rem" }} />
      <Stack spacing={1} alignItems="center">
        <Typography variant="h4" color="secondary">
          {translate("errors.permissionDenied.title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          {translate("errors.permissionDenied.pageMessage")}
        </Typography>
      </Stack>
    </Stack>
  );
};
